import React from 'react'
import "./orthopticassesment.css"



function OrthopticAssessment() {
  return (
    <>

        {/* Banner Image */}
        <div className="orthoptic-banner">  
            <img src="/orthoptic.jpg" alt="orthoptic Banner" className="orthoptic-banner-image" />
          </div>

    <div className="orthoptic-assessment-container">
    <h2>Orthoptic Assessment</h2>
      <p>An orthoptic assessment consists of a series of tests designed to examine how well both eyes function together. Binocular vision is essential for maintaining proper eye alignment and coordinated movement. The brain merges images from both eyes into a single, three-dimensional perception, which is crucial for understanding our surroundings. Since vision is one of the primary senses we use to gather environmental information, any inaccuracies in the signals sent to the brain can result in misinterpretation.</p>

      <p>When the eyes fail to provide accurate visual input, it can cause difficulties in depth perception, as well as challenges in recognizing colors, sizes, and orientations. This can particularly affect children, leading to disorientation, difficulty navigating spaces, and issues with fine and gross motor skills, which may impact their learning development.</p>

      <p>During the assessment, an orthoptist examines not only visual clarity but also the stability and coordination of binocular function. Based on the results, an appropriate treatment plan will be determined by the eye doctor.</p>

      <p>Treatment options may include specialized glasses, prisms, or filters, and vision therapy is often beneficial in improving the condition. In certain cases, surgical intervention may be required. Thanks to advancements in modern technology, many conditions that were once difficult to treat can now be effectively managed.</p>
    </div>
    </>
  )
}

export default OrthopticAssessment
